export const TopicLogosLocation = {
	default: '/img/logos/iq-education.png',
	orthographiq: '/img/logos/orthograph-iq.png',
	redaciq: '/img/logos/redac-iq.png',
	cyberiq: '/img/logos/cyber-iq.png',
};
